/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";

const Home = () => {
  const { authState, authService } = useOktaAuth();

  useEffect(() => {
    if (!authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      authService.login("/");
    } else {
      authService.getUser().then((info) => {
        if (
          info.groups !== undefined &&
          info.groups.indexOf(process.env.REACT_APP_TRAVELERPORTAL_GROUP) >= 0
        ) {
          clearStorageAndRedirect(process.env.REACT_APP_TRAVELERPORTAL_URL);
        } else if (
          info.groups !== undefined &&
          info.groups.indexOf(process.env.REACT_APP_AFFILIATEPORTAL_GROUP) >= 0
        ) {
          setCAUrl(info.groups);
        } else if (
          info.groups !== undefined &&
          info.groups.indexOf(process.env.REACT_APP_CIRO_CLIENT_GROUP) >= 0
        ) {
          setCiroUrl(info.groups);
        } else {
          clearStorageAndRedirect(process.env.REACT_APP_OKTA_USER_HOME);
        }
      });
    }
  }, [authState, authService]); // Update if authState changes

  if (authState.isPending) {
    return <div>Loading...</div>;
  }

  return <div></div>;
};
export default Home;

function clearStorageAndRedirect(url) {
  localStorage.clear(); // Clear local storage
  sessionStorage.clear(); // Clear session storage
  window.location.href = url;
}
function setPortalUrl(oktaGroups, urlMapping, defaultUrl) {
  for (const [group, url] of Object.entries(urlMapping)) {
    if (oktaGroups.includes(group)) {
      clearStorageAndRedirect(url);
      return;
    }
  }
  clearStorageAndRedirect(defaultUrl);
}

function setCAUrl(oktaGroups) {
  const urlMapping = {
    "Affiliate Portal QA": process.env.REACT_APP_AFFILIATEPORTAL_URL,
    "Affiliate Portal DEMO": process.env.REACT_APP_AFFILIATEPORTAL_URL_DEMO,
    "Affiliate Portal UAT": process.env.REACT_APP_AFFILIATEPORTAL_URL_UAT,
    "Affiliate Portal DEV": process.env.REACT_APP_AFFILIATEPORTAL_URL_DEV,
  };
  setPortalUrl(
    oktaGroups,
    urlMapping,
    process.env.REACT_APP_AFFILIATEPORTAL_URL,
  );
}

function setCiroUrl(oktaGroups) {
  const urlMapping = {
    "Ciro Client Portal QA": process.env.REACT_APP_CIRO_CLIENT_URL_QA,
    "Ciro Client Portal DEMO": process.env.REACT_APP_CIRO_CLIENT_URL_DEMO,
    "Ciro Client Portal UAT": process.env.REACT_APP_CIRO_CLIENT_URL_UAT,
    "Ciro Client Portal DEV": process.env.REACT_APP_CIRO_CLIENT_URL_DEV,
  };
  setPortalUrl(oktaGroups, urlMapping, process.env.REACT_APP_CIRO_CLIENT_URL);
}
